import React from 'react';
import { motion } from 'framer-motion';
import { Home, ArrowLeft } from 'lucide-react';
import Header from '../components/Header';

const NotFound = () => {
  return (
    <div className="min-h-screen bg-white dark:bg-black flex flex-col transition-colors duration-300">
      <Header />
      <main className="flex-grow flex items-center justify-center px-6">
        <div className="max-w-xl w-full text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <span className="text-blue-600 dark:text-blue-400 font-bold tracking-widest uppercase text-sm mb-4 block">
              404 Error
            </span>
            <h1 className="text-5xl md:text-7xl font-bold tracking-tight text-gray-900 dark:text-white mb-6 font-inter">
              Page not found
            </h1>
            <p className="text-xl text-gray-500 dark:text-gray-400 mb-12 font-inter">
              The page you are looking for doesn't exist or has been moved.
            </p>
            
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a 
                href="/"
                className="btn-primary px-8 py-4 flex items-center gap-2 w-full sm:w-auto justify-center"
              >
                <Home size={18} /> Go home
              </a>
              <button 
                onClick={() => window.history.back()}
                className="btn-secondary px-8 py-4 flex items-center gap-2 w-full sm:w-auto justify-center"
              >
                <ArrowLeft size={18} /> Go back
              </button>
            </div>
          </motion.div>
        </div>
      </main>
      
      <footer className="py-8 border-t border-gray-100 dark:border-gray-800 text-center">
        <p className="text-gray-400 dark:text-gray-500 font-inter text-xs">
          © {new Date().getFullYear()} Harsh Murjani. All rights reserved.
        </p>
      </footer>
    </div>
  );
};

export default NotFound;
